import React, { Component } from 'react';
import classes from './Footer.css';
import Container from '../../../hoc/Container/Container'
import Button from '../../UI/Button/Button';
import SimpleReactValidator from 'simple-react-validator';
import axios from '../../../firebase-axios';
import Popup from "react-popup";
import {sendEmailToMailer} from '../../../helpers/EmailHelper';
import Loader from '../../UI/Loader/Loader';
class Footer extends Component {
    state = {
        email:'',
        loading:false
    };
    componentWillMount() {
        this.validator = new SimpleReactValidator();
    }

    setEmail = (event) => {
        this.setState({email:event.target.value});
    }

    emailSubmit = (event) => {
        event.preventDefault();
        if (this.validator.allValid()) {
            this.setState({loading:true});       
            axios.post('emailList.json',{
                email:this.state.email,
                created_at:new Date().getMilliseconds()
            }).then(() => {
                sendEmailToMailer({
                    email:this.state.email
                }).then((res) =>{
                    Popup.alert('Thanks, I will get in touch with you soon.');
                    this.setState({loading:false});
                },(err) => {
                    Popup.alert('Something went wrong');
                    console.log(err);
                    this.setState({loading:false});
                })
                this.validator =  new SimpleReactValidator();
                this.setState({email:''});
            })
            .catch((err) => {
                Popup.alert('Something goes wrong');
                console.log(err);
                this.setState({loading:false});
            });
          } else {
            Popup.alert('Invalid Email');
            this.validator.showMessages();
            this.forceUpdate();
          }
    }

    updateEmailError = () => {
        this.validator.showMessageFor('email');
        this.setState({email:this.state.email});
    }

   render() {

    let getInTouchForm = (
                <form onSubmit={this.emailSubmit} className={classes.footerForm}>
                        <div className={classes.inputWrapper}>
                            <input 
                                value={this.state.email} 
                                className={classes.appFormControlFooter} 
                                placeholder="Enter your email" 
                                type="text" 
                                onChange={this.setEmail}
                                onBlur={this.updateEmailError}
                                />
                            {this.validator.message('email',this.state.email,'required|email',{ className: classes.textDanger })}
                        </div>
                        <Button isGetInTouch submit >Get in touch</Button>
                </form>
    
    );

    if(this.state.loading) {
        getInTouchForm = <Loader />
    }
        return (
            <footer className={classes.appFooter}>
            <Container>
                <div className={classes.footerContent}>
                    <div className={classes.footerTop}>
                        <div className={classes.footerSection}>
                            <h3 className={classes.footerTitle}>Get In Touch</h3>
                            <p className={classes.footerDescription}>Let's connect and discuss opportunities</p>
                            <div className={classes.appFormGroupFooter}>
                                {getInTouchForm}
                            </div>
                        </div>
                        <div className={classes.footerSection}>
                            <h3 className={classes.footerTitle}>Connect</h3>
                            <div className={classes.socialIcons}>
                                <a href="https://www.linkedin.com/in/mayank-sagar-11032859/" target="_blank" rel="noopener noreferrer">
                                    <i className="fa fa-linkedin"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className={classes.footerDivider}></div>
                    <div className={classes.footerBottom}>
                        <div className={classes.copyrights}>
                            <p>&copy; {new Date().getFullYear()} Mayank Sagar. All rights reserved.</p>
                        </div>
                    </div>
                </div>
            </Container>
            </footer>
        );
    }
};

export default  Footer;


// WEBPACK FOOTER //
// ./src/components/Navigation/Footer/Footer.js